import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as a } from "./SvgIcon.js";
const h = (r) => /* @__PURE__ */ o(a, { ...r, children: /* @__PURE__ */ o("path", { d: "M14.368 4.993a.625.625 0 0 0-.435 1.074l3.1 3.1H1.458a.625.625 0 1 0 0 1.25h15.575l-3.1 3.1a.627.627 0 0 0 .197 1.029.624.624 0 0 0 .687-.146l4.167-4.166a.625.625 0 0 0 0-.884l-4.167-4.167a.624.624 0 0 0-.449-.19Z" }) });
export {
  h as ArrowRight
};
//# sourceMappingURL=ArrowRight.js.map
